/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef} from 'react'

/**
 * @public
 */
export const TrendUpwardIcon = forwardRef(function TrendUpwardIcon(
  props: React.SVGProps<SVGSVGElement>,
  ref: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      data-sanity-icon="trend-upward"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        d="M4.5 18.5L11.5 10.5L13.5 14.5L20.5 6.5"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinejoin="round"
      />
      <path d="M20.5 11V6.5H16" stroke="currentColor" strokeWidth={1.2} strokeLinejoin="round" />
    </svg>
  )
})
TrendUpwardIcon.displayName = 'ForwardRef(TrendUpwardIcon)'
